<template>
  <div id="app" :style="{overflow:loginShow?'hidden':'initial'}" @click="clicked">
    <router-view />
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
  name: 'Login',
  data() {
    return {
      lastTime: new Date().getTime(), // 最后一次点击的时间
      currentTime: new Date().getTime(), // 当前时间
      overTime: 30 * 60 * 1000 // 默认超时时间(30分钟)
    };
  },
  computed: {
    ...mapGetters(['userInfo']),
    loginShow() {
      return this.$store.state.user.loginShow;
    }
  },
  mounted() {
    // 定时触发判断是否未点击
    window.setInterval(this.checkTime, 30000);
  },
  methods: {
    clicked() {
      this.lastTime = new Date().getTime(); // 当界面被点击更新点击时间
    },
    checkTime() {
      if (this.userInfo.overTime) {
        const minute = parseInt(this.userInfo.overTime);
        this.overTime = minute * 60 * 1000;
      }
      this.currentTime = new Date().getTime();
      if (this.currentTime - this.lastTime > this.overTime) {
        if (this.userInfo.accountId) {
          // 退出登录
          this.$store.dispatch('FedLogOut').then(() => {
            // location.reload();
            this.$router.push('/');
          });
        }
      }
    }
  }
};
</script>
<style lang="scss">
// #app {
//   height: 100%;
// }
</style>
